import SkillCard from './components/SkillCard';
export default {
  components: {
    SkillCard
  },
  props: {
    skillList: {
      type: Array,
      default: () => []
    },
    span: {
      type: Number,
      default: 8
    },
    cardStyle: {
      type: Object,
      default: () => ({})
    },
    lineClamp: {
      type: Number,
      default: 3
    }
  }
};